<template>
  <v-dialog v-model="dialog" scrollable max-width="520px">
    <v-card>
      <ErrorAlert :message="errorMessage" @clear-error="clearMessage" />
      <v-form class="fdlg__form" @submit.prevent="changePassword">
        <div class="fdlg__head">
          <div>
            <h2 class="fdlg__title">Schimbă parola</h2>
            <p class="fdlg__sub">Introduceți parola actuală, apoi de două ori parola nouă.</p>
          </div>
          <v-btn icon aria-label="Închide" @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="fdlg__body">
          <section class="form-section">
            <div class="form-section__label"><v-icon small>mdi-lock-outline</v-icon>Parola</div>
            <v-text-field
              v-model="oldPassword"
              label="Parola veche"
              prepend-inner-icon="mdi-lock-outline"
              outlined
              autocomplete="current-password"
              :type="showOldPassword ? 'text' : 'password'"
              :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showOldPassword = !showOldPassword"
              :error-messages="formErrors.oldPassword"
            ></v-text-field>
            <v-text-field
              v-model="newPassword"
              label="Parola nouă"
              prepend-inner-icon="mdi-lock-plus-outline"
              outlined
              autocomplete="new-password"
              :type="showNewPassword ? 'text' : 'password'"
              :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showNewPassword = !showNewPassword"
              :error-messages="formErrors.newPassword"
            ></v-text-field>
            <v-text-field
              v-model="confirmPassword"
              label="Confirmarea parolei noi"
              prepend-inner-icon="mdi-lock-check-outline"
              outlined
              autocomplete="new-password"
              :type="showConfirmPassword ? 'text' : 'password'"
              :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showConfirmPassword = !showConfirmPassword"
              :error-messages="formErrors.confirmPassword"
            ></v-text-field>
          </section>
        </v-card-text>

        <div class="fdlg__foot">
          <span v-if="formErrors.errorMessage" class="pw-error" role="alert">{{ formErrors.errorMessage }}</span>
          <v-spacer></v-spacer>
          <v-btn text large @click="closeDialog()">Anulare</v-btn>
          <v-btn class="btn-green" large type="submit">
            <v-icon left>mdi-content-save-outline</v-icon>Salvează parola
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import * as api from "../../views/users/api.js";
import ErrorAlert from "@/components/alerts/ErrorAlert.vue";

export default {
  components: {
    ErrorAlert,
  },
  data() {
    return {
      dialog: false,
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      errorMessage: "",
      formErrors: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        errorMessage: "",
      },
    };
  },
  methods: {
    show() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.clearFields();
    },
    clearFields() {
      this.formErrors = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        errorMessage: "",
      };
      this.oldPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
    },

    async changePassword() {
      this.validateForm();

      if (!this.isFormValid()) {
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.formErrors.confirmPassword = "Parola nu corespunde";
        return;
      }
      try {
        await api.changePassword(
          this.$store.getters.getUser.userId,
          this.oldPassword,
          this.newPassword
        );
        this.$emit("password-changed");
        this.closeDialog();
      } catch (error) {
        const message = error.response?.data?.message || "Parola veche nu este corectă";
        this.clearFields();
        // the field watchers run on the next tick and would wipe a message set right away
        await this.$nextTick();
        this.formErrors.errorMessage = message;
      }
    },
    validateForm() {
      this.formErrors.oldPassword = this.oldPassword
        ? ""
        : "Parola veche este obligatorie";
      this.formErrors.newPassword = !this.newPassword
        ? "Parola nouă este obligatorie"
        : this.newPassword.length < 8
          ? "Parola nouă trebuie să aibă cel puțin 8 caractere"
          : this.newPassword === this.oldPassword
            ? "Parola nouă trebuie să fie diferită de cea veche"
            : "";
      this.formErrors.confirmPassword = this.confirmPassword
        ? ""
        : "Confirmarea parolei este obligatorie";
    },
    isFormValid() {
      return !Object.values(this.formErrors).some((error) => error);
    },
    handleError(message) {
      this.errorMessage = message;
    },
    clearMessage() {
      this.errorMessage = "";
    },
  },
  watch: {
    // closing with Esc or a click outside also forgets what was typed
    dialog(open) {
      if (!open) this.clearFields();
    },
    oldPassword() {
      this.formErrors.oldPassword = "";
      this.formErrors.errorMessage = "";
    },
    newPassword(newVal) {
      this.formErrors.newPassword = "";
    },
    confirmPassword(newVal) {
      this.formErrors.confirmPassword = "";
    },
  },
};
</script>

<style scoped>
/* its own line above the buttons, so they stay put on the right */
.pw-error {
  flex: 1 0 100%;
  color: var(--brick);
  font-weight: 600;
}
</style>
